import {
  UDPATE_PERMISSION_CHECKER,
  UDPATE_PERMISSION_CHECKER_SUCCESS,
  UDPATE_PERMISSION_CHECKER_ERROR,
  UDPATE_PERMISSION_CHECKER_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdatePermissionRequest = (state = initialState, action) => {
  switch (action?.type) {
    case UDPATE_PERMISSION_CHECKER:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UDPATE_PERMISSION_CHECKER_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UDPATE_PERMISSION_CHECKER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case UDPATE_PERMISSION_CHECKER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdatePermissionRequest;
